export const collection = {
    noData: 'У вас пока нет NFT.',
    title: 'Ваша коллекция',
};
